import { defineMessages } from "react-intl";

const messages = defineMessages({
    browse: {
        id: "menu.browse",
    },
    testModeration: {
        id: "menu.moderation",
    },
});

export default messages;
